import Rest from "../../../../libs/Rest";

class DynamicViewRepository {
  rest;

  constructor() {
    this.rest = new Rest();
  }

  getView(endpoint, query_params) {
    this.rest.setParams(''+query_params);
    this.rest.setEndPoint(endpoint);
    return this.rest.get();
  }
}

export default DynamicViewRepository;